import React from "react";
import { withRouter } from "react-router";
import { injectIntl, FormattedHTMLMessage } from "react-intl";
import { Button } from "react-md";

import "./Privacy.css";
import pic1 from "../assets/img/dongle_1.png";
import pic2 from "../assets/img/dongle_2.png";
import pic3 from "../assets/img/trip_analysis.png";

export default withRouter(
  injectIntl(({ history }) => (
    <div className="privacy-main">
      <div className="privacy-text">
        <FormattedHTMLMessage id="privacy.privacy_message.message1" />
      </div>
      <div className="pic-set1">
        <img alt="blackbox example" src={pic1} />
        <img alt="blackbox position" src={pic2} />
        <br />
        <div className="privacy-text">
          <FormattedHTMLMessage id="privacy.privacy_message.caption1" />
        </div>
      </div>
      <div className="privacy-text">
        <FormattedHTMLMessage id="privacy.privacy_message.message2" />
      </div>
      <div className="pic-set2">
        <img alt="blackbox example" src={pic3} />
        <br />
        <div className="privacy-text">
          <FormattedHTMLMessage id="privacy.privacy_message.caption2" />
        </div>
      </div>
      <div className="privacy-text">
        <FormattedHTMLMessage id="privacy.privacy_message.message3" />
      </div>
      <div className="privacy-text">
        <FormattedHTMLMessage id="privacy.privacy_message.message4" />
      </div>
      <div className="privacy-text privacy-table">
        <FormattedHTMLMessage id="privacy.privacy_message.message5" />
      </div>
      <Button className="back-button" onClick={() => history.goBack()}>
        Back
      </Button>
    </div>
  ))
);



// WEBPACK FOOTER //
// ./src/components/Privacy.jsx